import React from "react";
import { Col, Row } from "react-bootstrap";
import { DiPython, DiGit, DiJava, DiHtml5, DiCss3, DiJavascript1, DiNodejs } from "react-icons/di"; // Python, Git, Java, HTML, CSS, JavaScript, Node.js
import { SiMysql, SiVisualstudiocode } from "react-icons/si"; // MySQL, VS Code

function Techstack() {
  return (
    <>
      {/* First Row */}
      <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <SiMysql /> {/* SQL */}
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiPython /> {/* Python */}
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiGit /> {/* Git */}
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiJava /> {/* Java */}
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiVisualstudiocode /> {/* VS Code */}
        </Col>
      </Row>

      {/* Second Row - 3 Skills */}
      <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <DiHtml5 /> {/* HTML */}
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiCss3 /> {/* CSS */}
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiJavascript1 /> {/* JavaScript */}
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <DiNodejs /> {/* Node.js */}
        </Col>
      </Row>

      {/* Last Row - 2 Skills */}
      <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        
           

           
      </Row>
    </>
  );
}

export default Techstack;
